var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "27px",
    viewBox: "0 0 20 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "0%",
    fx: "50%",
    fy: "0%",
    r: "114.424885%",
    gradientTransform: "translate(0.500000,0.000000),scale(0.200000,1.000000),rotate(60.919274),translate(-0.500000,-0.000000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "52.0361328%",
    x2: "100%",
    y2: "52.0361328%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A5A5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    offset: "48.8037109%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807D7D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6BB5\\u89C6\\u89D2\\u9875\\u9762",
    transform: "translate(-1979.000000, -1312.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(1979.000000, 1312.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "url(#radialGradient-1)",
    cx: 10,
    cy: 25,
    rx: 10,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0.5 L12,0.5 L12,25 C11.3333333,25.2600098 10.6666667,25.3900146 10,25.3900146 C9.33333333,25.3900146 8.66666667,25.2600098 8,25 L8,0.5 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStick);
export default __webpack_public_path__ + "static/media/stick.9b059955c407e54daae4a82670f5cff3.svg";
export { ForwardRef as ReactComponent };